import { render, staticRenderFns } from "./task-video-cards.vue?vue&type=template&id=6189c6d2&scoped=true"
import script from "./task-video-cards.vue?vue&type=script&lang=js"
export * from "./task-video-cards.vue?vue&type=script&lang=js"
import style0 from "./task-video-cards.vue?vue&type=style&index=0&id=6189c6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6189c6d2",
  null
  
)

export default component.exports